import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import moment from "moment-timezone";
import { Inbox } from "lucide-react";
import Spinner from "../../../../../../../components/shared/Spinner";
import ShiftCard from "./ShiftCard";
import { useClaimDialog } from "./useClaimDialog";
import { useDenyDialog } from "../../../../hooks/modals/useDenyDialog";
import { useFilters } from "../../../../../../../utils/hooks/useFilters";
import useApi from "../../../../../../../utils/api";
import { OPEN_SHIFTS_URL, REQUEST_TYPES } from "./constants";

function OpenShifts({ focusedRequest }: { focusedRequest?: string | null }) {
    const { t } = useTranslation();
    const [filters] = useFilters();
    const { authGet } = useApi();
    const { open: claim, dialog: claimDialog } = useClaimDialog();
    const { open: deny, dialog: denyDialog } = useDenyDialog({ queryOptions: { queryKey: [OPEN_SHIFTS_URL] } });

    const { data, isLoading } = useQuery({
        queryKey: [OPEN_SHIFTS_URL, {
            namespace: "schedule",
            pagination: "false",
            "filter[type][method]": "exact",
            "filter[type][value][]": REQUEST_TYPES,
            "filter[status][method]": "exact",
            "filter[status][value]": "pending",
            startDate: filters?.mode === "month" ? moment(filters?.from).startOf("week").format("YYYY-MM-DD") : filters?.from,
            endDate: filters?.mode === "month" ? moment(filters?.to).endOf("week").format("YYYY-MM-DD") : filters?.to,
        }],
        queryFn: ({ queryKey, signal }: any) => {
            const [url, params] = queryKey;
            return authGet(url, { params, signal });
        },
    });

    const requests: any[] = data?.result || [];

    return (
        <>
            {isLoading ? (
                <div className="tw-flex tw-items-center tw-justify-center tw-py-7">
                    <Spinner className="tw-text-primary" />
                </div>
            ) : requests.length > 0 ? (
                <div>
                    {requests.map((request) => (
                        <ShiftCard
                            key={request.id}
                            request={request}
                            claim={claim}
                            deny={deny}
                            focused={request.id === focusedRequest}
                        />
                    ))}
                </div>
            ) : (
                <div className="tw-flex tw-flex-col tw-items-center tw-text-neutral-500 tw-border tw-rounded-sm tw-py-7">
                    <Inbox />
                    <span>{t("no-data")}</span>
                </div>
            )}

            {claimDialog}
            {denyDialog}
        </>
    );
}

export default OpenShifts;
